import { BaseFormula } from "../../BaseFormula";
import { CalculationResult } from "../../CalculationResult";
import { ChangeType } from "../../ChangeType";
import { CostData } from "../../CostData";

export class Formula_GrubbsTest extends BaseFormula
{
    evaluate(data: CostData[], value: CostData, change: ChangeType, parameters: { alpha: number }, show_new_cost: boolean): CalculationResult
    {
        let err = this.checkLength(data, 3, show_new_cost);
        if (err)
            return err;

        let mean = data.reduce((a, b) => a + b.amount, 0) / data.length;
        let variance = data.reduce((a, b) => a + Math.pow(b.amount - mean, 2), 0) / data.length;
        let standard_deviation = Math.sqrt(variance);

        if (standard_deviation === 0)
            return {
                value: null,
                reason: `Standard Deviation is zero.`,
                values: { mean, variance, standard_deviation }
            };

        let g = (value.amount - mean) / standard_deviation;

        err = this.checkChnage(change, g, { mean, variance, standard_deviation, g });
        if (err)
            return err;

        let length = data.length;
        let ditribution = this.tDistribution(length - 2, parameters.alpha / (2 * length)); // Two-tailed
        let numerator = (length - 1) * Math.sqrt(Math.pow(ditribution, 2));
        let denominator = Math.sqrt(length - 2 + Math.pow(ditribution, 2)) * Math.sqrt(length);
        let critical_value = numerator / denominator;

        return {
            value: Math.abs(g) > critical_value,
            values: { mean, variance, standard_deviation, g, length, ditribution, numerator, denominator, critical_value }
        };
    }

    private tDistribution(df: number, alpha: number): number
    {
        const tTable: Record<number, Record<number, number>> = {
            1: { 0.10: 3.08, 0.05: 6.31, 0.01: 31.82 },
            2: { 0.10: 1.89, 0.05: 2.92, 0.01: 6.96 },
            3: { 0.10: 1.64, 0.05: 2.35, 0.01: 4.54 },
            4: { 0.10: 1.53, 0.05: 2.13, 0.01: 3.75 },
            5: { 0.10: 1.48, 0.05: 2.02, 0.01: 3.36 },
            6: { 0.10: 1.44, 0.05: 1.94, 0.01: 3.14 },
            10: { 0.10: 1.37, 0.05: 1.81, 0.01: 2.76 },
            20: { 0.10: 1.33, 0.05: 1.73, 0.01: 2.53 },
            30: { 0.10: 1.31, 0.05: 1.70, 0.01: 2.46 },
            50: { 0.10: 1.299, 0.05: 1.676, 0.01: 2.403 },
        };

        const closestDf = Object.keys(tTable)
            .map(k => parseInt(k))
            .reduce((prev, curr) => Math.abs(curr - df) < Math.abs(prev - df) ? curr : prev);

        const alphaRounded = alpha >= 0.05 ? 0.05 : 0.01;

        return tTable[closestDf]?.[alphaRounded] ?? 1.96;
    }
} 